var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return false
    ? _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.shouldShowGuideBtn,
              expression: "shouldShowGuideBtn",
            },
          ],
          staticClass: "narrator-guide-btn",
          on: {
            mouseenter: function ($event) {
              _vm.onHover = true
            },
            mouseleave: function ($event) {
              _vm.onHover = false
            },
          },
        },
        [
          _c(
            "IButton",
            {
              staticClass: "btn-ghost",
              attrs: { id: "IStagingTourGuideBtn" },
              on: { click: _vm.onTourGuideBtnClick },
            },
            [
              _vm.onHover || _vm.isActive
                ? _c("i", { staticClass: "isif isif-telephone-ringing" })
                : _c("i", { staticClass: "isif isif-telephone-fill" }),
            ]
          ),
          _vm._v(" "),
          _c("ModalTourGuide", {
            ref: "ModalTourGuide",
            on: {
              close: function ($event) {
                _vm.isActive = false
              },
              showCalendar: function ($event) {
                return _vm.$emit("showCalendar")
              },
            },
          }),
          _vm._v(" "),
          _c("ModalWebRtcNotSupport", { ref: "ModalWebRtcNotSupport" }),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "narrator-guide-tip",
              class: [_vm.onHover ? "hover" : ""],
            },
            [_c("span", [_vm._v(_vm._s(_vm.$t("GuidedTour")))])]
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }